import React from 'react';
import { useState, useRef } from 'react';
import { useAuthorisation } from './AuthorisationProvider';
import SignupPage from "./SignupPage";
import "./LoginPage.css"

function LoginPage() {
    const [signup, setSignup] = useState(false)
    const [input, setInput] = useState({
        email: "",
        password: ""
    })
    const [loginError, setLoginError] = useState(false)
    const formRef = useRef(null)

    const handleInput = (e) => {
        const { name, value } = e.target;
        setInput((previousInput) => ({
            ...previousInput,
            [name]:value
        }));
        if (loginError)
            setLoginError(false)
    }

    const authorisation = useAuthorisation()
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (input.username !== "" && input.password !== "") {
            const result = await authorisation.loginAction(input);
            if (!result)
                return;
            else {
                setLoginError(true);
            }
        }
    }

    return (
        <div className={"login-container" + (authorisation.loadingLogin ? " loading" : "")}>
            <div style={{ display: signup ? 'none' : 'block' }}>
                <h4>Log in to your account:</h4>
                <form onSubmit={handleSubmit } ref={formRef}>
                    <div className="form-element">
                        <label>User Name:
                            <input
                                type="text"
                                id="user-name"
                                name="username"
                                placeholder="..."
                                onChange={handleInput }
                            />
                        </label>
                    </div>
                    <div className="form-element">
                        <label>Password:
                            <input
                                type="password"
                                id="user-password"
                                name="password"
                                placeholder="------------"
                                onChange={handleInput}
                            />
                        </label>
                    </div>
                    <div className="error login" style={{ display: loginError ? 'block' : 'none' }}>
                        Unable to log in with these credentials, check for errors and try again
                    </div>
                    <div className="button-container">
                        <input type="submit" value="Log In" className="button loginpage" />
                        <button type="button" className="button loginpage" onClick={() => {
                            setSignup(true)
                            formRef.current.reset()
                        }}>Create New Account</button>
                    </div>
                </form>
            </div>
            <div style={{ display: signup ? 'block' : 'none' }}>
                <h4>Sign up for a new account:</h4>
                <SignupPage setSignup={setSignup}/>
            </div>
        </div>
    );
}

export default LoginPage;